<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="gotomanageaction()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Manage Action Details
            </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">

        <div class="row">

            <div class="col-sm-12 col-md-6 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>Activity No</mat-label>
                    <input matInput  maxlength="25" formControlName="activityNo"
                        placeholder="Enter Activity No" class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-6 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>Activity Type</mat-label>
                    <input matInput  maxlength="25" formControlName="activityType"
                        placeholder="Enter Activity Type" class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
        </div>
        <div class="row">

            <div class="col-sm-12 col-md-6 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>person Responsible</mat-label>
                    <input matInput  maxlength="25" formControlName="personResponsible"
                        placeholder="Enter person Responsible" class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-6 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>TargetDate</mat-label>
                    <input matInput  maxlength="25" formControlName="targetDate"
                        placeholder="Enter Naming Convention" class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-md-6 mt-4">
                <mat-form-field appearance="fill" hideRequiredMarker>
                    <mat-label>customer Name</mat-label>
                    <input matInput appInputtext maxlength="25" formControlName="customerName"
                        placeholder="Enter Naming Convention" class="col-10" autocomplete="off">
                </mat-form-field>
            </div>
            <div class="col-sm-12 col-xl-6 mt-4" >
    
                <mat-form-field appearance="fill" hideRequiredMarker
                [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                <mat-label>Comments</mat-label>
                <textarea rows="4" matInput type="text" placeholder="Enter Query"
                    formControlName="comments" autocomplete="off" specialIsAlphaNumeric
                    class="col-12"></textarea>
            </mat-form-field>
              </div>
        </div>
        <div class="row" *ngIf="actionvisible">

            <div class="col-sm-12 col-xl-6 mt-4" >
    
                <mat-form-field appearance="fill" hideRequiredMarker
                [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                <mat-label>Action</mat-label>
                <textarea rows="4" matInput type="text" placeholder="Enter Action"
                    formControlName="actionComments" autocomplete="off" specialIsAlphaNumeric
                    class="col-12"></textarea>
            </mat-form-field>

              </div>
              <div class="col-sm-12 col-md-6 col-xl-6 mt-5">
                <div class="col-sm-12 col-md-6" style="display: flex; align-items: center;">
                  <mat-checkbox formControlName="complete" style="transform: scale(1.3);" color="primary"></mat-checkbox>
                  <label style="margin-left: 30px; font-size: large; white-space: nowrap;">
                    Mark as Complete
                  </label>
                </div>
              </div>
        </div>
        <div class="d-flex justify-content-end button-style mt-3">
            <button class="btn btn-primary my-2 mr-3" type="submit" (click)="gotomanageaction()"
            matButton>Cancel</button>
            <button class="btn btn-secondary my-2 " type="submit" (click)="save()" *ngIf="!savedisble"
                matButton>Save</button>
               
        </div>
        </form>
        <div class="container my-4">
            <div class="row">
                <div class="col-12 ">
                    <span class="title_header_bar">
                      
                        Previous Action 
                    </span>
                </div>
            </div>
            <div class="card card_content">
                <div class="table-responsive mt-2 mb-4">
                    <mat-table #table [dataSource]="dataSource" >
            
                      <ng-container matColumnDef="ActionTakenBy">
                        <mat-header-cell *matHeaderCellDef >Action Taken By</mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                          <p class="text-truncate txtalign"> {{dataField.actionTakenName}}</p>
                        </mat-cell>
                      </ng-container>
            
                      <ng-container matColumnDef="ActionTakenOn">
                        <mat-header-cell *matHeaderCellDef >Action Taken On</mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                          <p class="text-truncate txtalign"> {{dataField.displayActionTakenDate}} </p>
                        </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="ActionComments">
                            <mat-header-cell *matHeaderCellDef >Action Comments</mat-header-cell>
                            <mat-cell *matCellDef="let dataField">
                              <p class="text-truncate txtalign"> {{dataField.actionComments}} </p>
                            </mat-cell>
                            </ng-container>

            
                      <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
            
                      <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                      </mat-row>
                     
                    </mat-table>
                    <div *ngIf="dataSource.filteredData.length === 0" 
                    class="no-data-message" >
                    <p>No data found</p>
                    </div>
                  </div>
    </div>
</div>
    